import script from "./UsersView.vue?vue&type=script&setup=true&lang=ts"
export * from "./UsersView.vue?vue&type=script&setup=true&lang=ts"

import "./UsersView.vue?vue&type=style&index=0&id=383ea634&lang=scss"

const __exports__ = script;

export default __exports__